export function capitalizeFirst(text) {
  if (typeof text !== 'string') throw new RangeError('The input must be a string.');
  return text.charAt(0).toUpperCase() + text.slice(1);
}